import PatientsFilter from './patients-filter';

export default PatientsFilter;
